var _excluded = ["children"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledAvatar } from './Avatar.styled';
function Avatar(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledAvatar, rest, children);
}
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Used in combination with src to provide an alt
   * attribute for the rendered img element.
   */
  alt: PropTypes.string.isRequired,
  /**
   * Used to render icon or text elements inside the
   * Avatar if src is not set. This can be an element,
   * or just a string.
   */
  children: PropTypes.node,
  /**
   * Defines the size of component
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * The `src` attribute for the `img` element.
   */
  src: PropTypes.string,
  /**
   * The `srcSet` attribute for the `img` element. Use this attribute for responsive image display.
   */
  srcSet: PropTypes.string,
  /**
   * The shape of the avatar.
   */
  variant: PropTypes.oneOf(['circular', 'rounded', 'square'])
} : {};
Avatar.defaultProps = {
  children: '',
  size: 'small',
  src: '',
  srcSet: '',
  variant: 'circular'
};
export default Avatar;